import React from "react";
// import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
    columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import DuesFilterDialogWrapper from "./FilterDialog/DuesFilterDialogWrapper";

type Props = {
    columns: columnTypes[];
    getDuesExcel: any
    isloadingExcel: boolean
    rows: any[];
    // excelData: any[];
    paginationProps: {
        isTableLoading: boolean;
        totalItems: number;
        page: number;
        rowsPerPage: number;
        searchValue: string;
        setPage: (newPage: number) => void;
        setRowsPerPage: (newLimit: number) => void;
        setSearchValue: (newValue: string) => void;
    };
};

const DuesListing = ({
    columns,
    rows,
    // excelData,
    // getDuesExcel,
    // isloadingExcel,
    paginationProps: {
        isTableLoading,
        totalItems,
        page,
        rowsPerPage,
        searchValue,
        setPage,
        setRowsPerPage,
        setSearchValue,
    },
}: Props) => {
    // const { dateFilter } = useSelector((state: RootState) => state.dues);
    // const [DuesExcel, setDuesExcel] = React.useState([])
    const [openFilterDialog, setOpenFilterDialog] = React.useState<boolean>(false);

    // const excelPayemntData = DuesExcel?.map((ele: any) => {
    //     const { __v, _id, DuesModeId, updatedAt, orderId, franchiseId, DuesMode, createdById, createdAt, franchise, ...rest } = ele;
    //     return { createdAt: formatedDateTimeIntoIst(createdAt, "DD MMM yyyy"), ...rest };
    // });
  

    return (
        <SideNavLayout>
            <div className="flex flex-col h-full p-4">
                {/* Page Header */}
                <div className="p-4">
                    <ATMPageHeader
                    moduleName="Dues"
                        pageTitle="Duess"
                        searchValue={searchValue}
                        isFilter
                        onFilterClick={() => setOpenFilterDialog(true)}
                        onSearchChange={setSearchValue}
                        hideAddButton
                    />
                </div>

                {/* <div className="flex justify-between items-center mx-3 my-1  mb-4" >
                  
                    <ATMExportButton
                        headers={[
                            { label: "Date-Time", key: "createdAt" },
                            { label: "Franchise name", key: "franchiseName" },
                            { label: "Mobile Number", key: "mobile" },
                            { label: "Actual Amount", key: "actualAmount" },
                            { label: "Adjust Against Mobile", key: "adjustAgainstMobile" },
                            { label: "Due Amount", key: "dueAmount" },


                        ]}
                        // ref={'exportRef'}
                        fileName='Dues-excel.csv'
                        onClick={(done) => {
                            getDuesExcel({
                                limit: rowsPerPage,
                                searchValue: searchValue,
                                params: ["mobile"],
                                page: page,
                                filterBy: [],
                                dateFilter: {
                                    startDate: dateFilter.start_date
                                        ? moment(dateFilter?.start_date).format("YYYY-MM-DD")
                                        : "",
                                    endDate: dateFilter.end_date
                                        ? moment(dateFilter?.end_date).format("YYYY-MM-DD")
                                        : dateFilter.start_date ? moment().format("YYYY-MM-DD") : ''
                                },
                                orderBy: "createdAt",
                                orderByValue: -1,
                                isPaginationRequired: false,
                            }).then((res: any) => {
                                if (res.data?.status) {
                                    setDuesExcel(res?.data?.data);
                                    setTimeout(() => {

                                        done()
                                    }, 1000)
                                }
                            })

                        }}
                        btnName="Export"
                        loadingText="Exporting..."
                        data={excelPayemntData}
                        isLoading={isloadingExcel}
                    />
                </div> */}
                {/* Table */}
                <div className="flex-1 overflow-auto flex flex-col">
                    <ATMTable
                        columns={columns}
                        rows={rows}
                        rowExtraClasses={() => "min-h-[40px]"}
                        isLoading={isTableLoading}
                    />
                </div>

                <div className="p-4 py-2">
                    <ATMPagination
                        page={page}
                        rowsPerPage={rowsPerPage}
                        onPageChange={setPage}
                        onRowsPerPageChange={setRowsPerPage}
                        rowCount={totalItems}
                        rows={rows}
                    />
                </div>
                {openFilterDialog ? <DuesFilterDialogWrapper onClose={() => { setOpenFilterDialog(false) }} /> : null}
            </div>
        </SideNavLayout>
    );
};

export default DuesListing;
